import type { Discount, PaymentMethodDetails, Plan } from '@takeshape/util';
import type { ReactElement } from 'react';

export enum IMPORT_STATUS {
  NOT_STARTED = 'Create Project',
  PENDING = 'Starting import...',
  RUNNING = 'Creating'
}

export type BoundAction<T extends (...args: any) => any> = (...args: Parameters<T>) => void;

// This type was isolated during the Meshectomy. It's worth considering if
// it should continue to exist.
export type Suggestion = {
  label: string;
  value: string;
};

export type SortOrder = 'asc' | 'desc';

export type Sort = {
  field: string;
  order: SortOrder;
};

export type GetProps<P> = (props?: Partial<P>) => P;

// MUI does not export this
export type GridAxis = number | [start: number, end: number];

export type RawErrorLocation = {
  line: number;
  column: number;
};

export type RawError = {
  message: string;
  locations: RawErrorLocation[];
  path: string[];
  extension: unknown;
};

export type GraphQLError = {
  message?: string;
  rawError?: RawError[];
  rawGraphQLData?: Record<string, any>;
};

/**
 * Recurring pattern for fetched data
 */
export type ContentState<Data> = {
  data: Data | null;
  loading: boolean;
  saving: boolean;
  loaded: boolean;
  error: string | null | GraphQLError;
};

export type SaveBillingResponse = {
  billing: {
    paymentMethodDetails: PaymentMethodDetails | null;
    discount: Discount | null;
    email: string;
    plan: Plan;
    trialEnd: null;
  };
};

type Renderable = number | string | ReactElement | Renderable[];

export type PropsWithCallableChildren<P, Q> = P & {
  children: (value: Q, index: number) => Renderable | undefined;
};
